import { render, staticRenderFns } from "./RankingLevelGroup.vue?vue&type=template&id=4355a74d&lang=pug"
import script from "./RankingLevelGroup.vue?vue&type=script&lang=js"
export * from "./RankingLevelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports